var _a;
import * as React from 'react';
import { createSvgIcon, IconDirectionality } from '..';
export var TriangleDown = createSvgIcon((_a = {},
    _a[IconDirectionality.All] = (React.createElement(React.Fragment, null,
        React.createElement("path", { fill: "currentColor", stroke: "transparent", d: "M12.5 5h-9L8 11l4.5-6z" }))),
    _a), 'small');
//# sourceMappingURL=TriangleDown.js.map